<template>
  <div>
  <div>
    <cms-content-tbl-publish-list v-if="visiblePublishList"></cms-content-tbl-publish-list>
  </div>
  
  <div>
    <cms-content-tbl-list v-if="visibleContentList" :colid="this.colid"></cms-content-tbl-list>
  </div>

  <div>
   <CmsContentAppList v-if="appListIsShow" :colid="this.colid "/>
  </div>

</div>

</template>

<script>
import CmsContentTblPublishList from './CmsContentTblPublishList'
import CmsContentTblList from './CmsContentTblList'
import CmsContentAppList from './CmsContentAppList'
export default {
  name: 'CmsContentTblPublish',
  components: {
    CmsContentTblPublishList,
    CmsContentTblList,
    CmsContentAppList
  },
  data () {
    return {
      visiblePublishList:true,
      visibleContentList:false,
      appListIsShow:false,
      colid:""
    }
  },
  created() {
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    tabChange(id) {
      if(id==null||typeof(id)=='undefined'){
          this.visiblePublishList=true;
          this.visibleContentList=false;
          this.appListIsShow = false
      }else{
        this.visiblePublishList=false;
        this.visibleContentList=true;
        this.colid=id;
      }
    },
    appList(id){
        this.visiblePublishList=false;
        this.visibleContentList=false;
        this.appListIsShow = true
        this.colid=id;
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
